// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarLayout_root__AIhce","header":"SidebarLayout_header__wzy2Q","container":"SidebarLayout_container__PJ0LF"};